import { Box, Typography } from '@mui/material'
import type { ProcurementFilters } from '../ProcurementPage'

interface Props {
  filters: ProcurementFilters
}

export default function ProcurementContractDetailView({ filters }: Props) {
  return (
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="h6" fontWeight={700}>
        Contract Detail
      </Typography>
      <Typography variant="body2" color="text.secondary">
        This tab will surface Procurement Contract Detail (P/NPE) views that mirror
        {' '}
        <strong>frmProcurementMainSubFormDetailsP</strong>
        {' '}
        and
        {' '}
        <strong>frmProcurementMainSubFormDetailsNPE</strong>
        , including internal Pay Info / Advance / Fixation sub-tabs.
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Current header filters: startDate={filters.startDate}, endDate={filters.endDate}, isForcedClose=
        {filters.isForcedClose}
        .
      </Typography>
    </Box>
  )
}

